import { render, staticRenderFns } from "./_base-popover.vue?vue&type=template&id=68969076&scoped=true&"
import script from "./_base-popover.vue?vue&type=script&lang=js&"
export * from "./_base-popover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68969076",
  null
  
)

export default component.exports